module.exports = __webpack_public_path__ + "img/icon.5beef750.png";